import { parseFullName } from 'parse-full-name';
import { copyFor } from 'config';
import { getJoiner } from 'utils/format';
import { AdvocacyRepresentatives } from 'contexts/advocacy/advocacy.typings';

const getCopy = copyFor('advocacy.message.titles');
const getGreetingCopy = copyFor('advocacy.message');

export const addTitleToLastName = (
  representative: AdvocacyRepresentatives[number]
) => {
  if (!representative.name) return;
  const lastName = parseFullName(representative.name).last;
  const titledAsRepresentative = getCopy('representative', { lastName });
  if (!representative.title) return titledAsRepresentative;
  if (representative.title.includes('Senator')) {
    return getCopy('senator', { lastName });
  } else if (representative.title.includes('Council')) {
    return getCopy('councilMember', { lastName });
  } else {
    return titledAsRepresentative;
  }
};

const getRepresentativeNames = (representatives?: AdvocacyRepresentatives) => {
  const representativeArray = representatives || [];
  const representativeTitledNames = representativeArray
    .map(representative => addTitleToLastName(representative))
    .filter(titledName => !!titledName);
  return representativeTitledNames.reduce((accumulator, titledName, index) => {
    return `${accumulator}${titledName}${getJoiner(
      index,
      representativeTitledNames.length
    )}`;
  }, '');
};

export const getGreeting = (
  representatives?: AdvocacyRepresentatives
): string => {
  const nameString = getRepresentativeNames(representatives);
  return nameString
    ? getGreetingCopy('greeting', {
        representativeNames: nameString,
      })
    : '';
};
